import Vue from "vue";
import Vuex from "vuex";

import solution from "./solution/index";
import cityCenter from "./cityCenter/index";
import user from "./user/index";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    solution,
    cityCenter,
    user
  },

  state: {},
  mutations: {},
  actions: {}
});
